import type { MapInfoWindowProps } from "./map-info-window.type";

import { CloseOutlined } from "@ant-design/icons";
import { InfoWindow } from "@vis.gl/react-google-maps";
import { Button } from "antd";

import MapInfoWindowItem from "../map-info-window-item";

import { getInfoWindowPixelOffset } from "./map-info-window.helper";

import "./map-info-window.style.less";

const MapInfoWindow = ({ marker, anchor, onClose }: MapInfoWindowProps) => {
  const pixelOffset = getInfoWindowPixelOffset(marker);
  const siblings = marker.siblings ?? [];

  return (
    <InfoWindow
      anchor={anchor}
      pixelOffset={pixelOffset}
      disableAutoPan={false}
      headerDisabled
    >
      <div className="map-info-window">
        <MapInfoWindowItem marker={marker} strong />
        {siblings.map((sibling) => (
          <MapInfoWindowItem key={sibling.key} marker={sibling} />
        ))}
        <Button
          type="text"
          shape="circle"
          size="small"
          icon={<CloseOutlined />}
          onClick={onClose}
          className="map-info-window-close-button"
        />
      </div>
    </InfoWindow>
  );
};

export default MapInfoWindow;
